import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-12f7d961"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-husbandry" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title f-size-24 f-col-white08" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "基础信息:")
], -1))
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "descriptions-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "养殖场名称：", -1))
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "descriptions-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "公司地址：", -1))
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "descriptions-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "法人代表：", -1))
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "descriptions-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "联系方式：", -1))
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "descriptions-item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "饲养情况：", -1))
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "descriptions-item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "养殖种类：", -1))
const _hoisted_24 = { class: "value" }
const _hoisted_25 = { class: "descriptions-item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "存栏量：", -1))
const _hoisted_27 = { class: "value" }
const _hoisted_28 = { class: "descriptions-item" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "清粪方式：", -1))
const _hoisted_30 = { class: "value" }
const _hoisted_31 = { class: "descriptions-item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "通风方式：", -1))
const _hoisted_33 = { class: "value" }
const _hoisted_34 = { class: "descriptions-item" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "粪便处理工艺：", -1))
const _hoisted_36 = { class: "value" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "btn" }, "视频监控")
], -1))

import { toRefs, nextTick, getCurrentInstance, onMounted } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'DialogHusbandry',
  props: {
  data: Object,
},
  setup(__props) {

const props = __props
const { data } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(data).mc || '-'), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(data).mc || '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(data).dz || '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(data).frdb || '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(data).lxfs || '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(data).shzt || '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(data).yzzl), 1)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(data).sjclgm || '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(data).qsQsffs || '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(data).qsTffs || '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("span", _hoisted_36, _toDisplayString(_unref(data).fbClgy || '-'), 1)
        ])
      ])
    ]),
    _hoisted_37
  ]))
}
}

})